// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import VueAlertify from 'vue-alertify'
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)
Vue.use(VueAlertify)
// import * as VueGoogleMaps from 'vue2-google-maps'

try {
  require('./config/' + process.env.NODE_ENV)
  require('./_public')

  /* Vue.use(VueGoogleMaps, {
    load: {
      key: window.AppConfig.googleApiKey,
      libraries: 'places'
    }
  }) */

  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      if (!store.getters.isLoggedIn) {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    } else if (to.matched.some(record => record.meta.requiresGuest)) {
      if (store.getters.isLoggedIn) {
        next({
          path: '/',
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    } else {
      next()
    }
  })
  if (store.getters.isLoggedIn) {
    store.dispatch('saveTokens', {tokens: store.getters.accessTokens, accountData: null, isLocalLogin: true})
  }

  Vue.use(BootstrapVue)

  Vue.config.productionTip = false
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
      App
    }
  })
} catch (ex) {
  alert('Can\'t find config file !!!')
}



// WEBPACK FOOTER //
// ./src/main.js